// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"45e6bda4","135":"265473f8","319":"3352940a","411":"95e5e4e1","488":"95a778c1","601":"71a57b9a","910":"84122dde","982":"f8bde796"}[chunkId] + ".chunk.js";
};